import MainHeader from "../../components/layout/MainHeader";
import PageHeader from "../../components/layout/PageHeader";
import Footer from "../../components/layout/Footer";
import img from "../../assets/images/background/13a.jpg";
import figureImg1 from "../../assets/images/quality/certifications/news-1.jpg";
import figureImg2 from "../../assets/images/quality/certifications/news-2.jpg";
import figureImg3 from "../../assets/images/quality/certifications/news-3.jpg";
import figureImg4 from "../../assets/images/quality/certifications/news-4.jpg";
import figureImg5 from "../../assets/images/quality/certifications/news-5.jpg";
import figureImg6 from "../../assets/images/quality/certifications/news-6.jpg";
import figureImg7 from "../../assets/images/quality/certifications/news-7.jpg";
import figureImg8 from "../../assets/images/quality/certifications/news-8.jpg";
import figureImg9 from "../../assets/images/quality/certifications/news-9.jpg";
import figureImg10 from "../../assets/images/quality/certifications/nile.png";
import figureImg11 from "../../assets/images/quality/certifications/pertrojet.jpg";
import figureImg12 from "../../assets/images/quality/certifications/redcon.png";
import figureImg13 from "../../assets/images/quality/certifications/tag misr.png";
import figureImg14 from "../../assets/images/quality/certifications/TMG.webp";
import certificatImg1 from "../../assets/images/quality/certifications/1.jpg";
import certificatImg2 from "../../assets/images/quality/certifications/2.jpg";
import certificatImg3 from "../../assets/images/quality/certifications/3.jpg";
import certificatImg4 from "../../assets/images/quality/certifications/4.jpg";
import certificatImg5 from "../../assets/images/quality/certifications/1.png";
import certificatImg6 from "../../assets/images/quality/certifications/2.png";
import certificatImg7 from "../../assets/images/quality/certifications/3.png";
import certificatImg8 from "../../assets/images/quality/certifications/4.png";
import certificatImg9 from "../../assets/images/quality/certifications/5.png";
import certificatImg10 from "../../assets/images/quality/certifications/6.png";
import certificatImg11 from "../../assets/images/quality/certifications/7.png";
import certificatImg12 from "../../assets/images/quality/certifications/8.png";
import certificatImg13 from "../../assets/images/quality/certifications/9.png";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const allCerts = [
  certificatImg1, certificatImg2, certificatImg3, certificatImg4,
  certificatImg5, certificatImg6, certificatImg7, certificatImg8,
  certificatImg9, certificatImg10, certificatImg11, certificatImg12, certificatImg13,
];

const newsImages = [
  figureImg14, figureImg13, figureImg12, figureImg11, figureImg10, figureImg1, figureImg2, figureImg3, figureImg4, figureImg5,
  figureImg6, figureImg7, figureImg8, figureImg9,
];

function Certifications() {
  const { t } = useTranslation();

  return (
    <>
      <MainHeader />
      <PageHeader image={img} title={t("Certifications")} />

      <section className="cert-section">
        <div className="container">
          {/* Header row */}
          {/* <div className="d-flex align-items-center justify-content-between flex-wrap gap-3 mb-4">
            <div>
              <span className="page-section-label">{t("Quality")}</span>
              <h2 className="inner-page-heading" style={{ marginBottom: 0 }}>
                {t("Consulting engineering approvals")}
              </h2>
            </div>
            <Link to="/accreditation" className="cert-link-btn">
              <i className="bi bi-award" />
              {t("Product accreditation")}
            </Link>
          </div> */}

          {/* <p className="cert-intro">{t("accreditation-info")}</p> */}

          {/* Certificate cards */}
          {/* <div className="cert-grid">
            {allCerts.map((src, i) => (
              <a
                key={i}
                href={src}
                target="_blank"
                rel="noreferrer"
                className="cert-card"
                aria-label={`Certificate ${i + 1}`}
              >
                <img src={src} alt={`Certificate ${i + 1}`} />
              </a>
            ))}
          </div> */}

          {/* News / Site images */}
          <h3
            className="inner-page-heading"
            style={{ marginTop: "56px", fontSize: "clamp(26px,4vw,40px)" }}
          >
            {t("Certifications")} — Site Gallery
          </h3>
          <div className="cert-grid">
            {newsImages.map((src, i) => (
              <a
                key={i}
                href={src}
                target="_blank"
                rel="noreferrer"
                className="cert-card"
                style={{ padding: 0, minHeight: "220px" }}
                aria-label={`Gallery image ${i + 1}`}
              >
                <img
                  src={src}
                  alt={`Site ${i + 1}`}
                  style={{ width: "100%", height: "160px" }}
                />
              </a>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default Certifications;
